import { memo, useCallback, useEffect, useState } from 'react';
import { View, StyleSheet, FlatList, Text, Pressable } from 'react-native';

import { I18n, Navigation, NavBar, Container, FormFooter, CheckBox } from '../components';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getCurrentTopic } from './selector';
import { getCurrentCaseParticipantsExcludingCurrentUser } from '../cases/selector';
import { getAllStaffFollowersExceptCurrentUser } from '../../selectors/employers';
import { createTopic, updateTopic } from './actions';
import navModes from './nav_modes';

function mapStateToProps(state) {
  const navMode = state.screens.messaging.navMode;
  let followers = [];
  if (navMode === navModes.CASE) {
    const currentCaseParticipants = getCurrentCaseParticipantsExcludingCurrentUser(state);
    followers = currentCaseParticipants.map((p) => p.profile);
  } else if (navMode === navModes.EMPLOYER) {
    followers = getAllStaffFollowersExceptCurrentUser(state);
  }
  return {
    navMode,
    currentCaseId: state.application.currentCaseId,
    currentTopicId: state.application.currentTopicId,
    currentTopic: getCurrentTopic(state),
    followers: followers.sort((a, b) => {
      if (a.fullName > b.fullName) return 1;
      if (b.fullName > a.fullName) return -1;
      return 0;
    }),
    user: state.user,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ createTopic, updateTopic }, dispatch),
  };
}

export default memo(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )((props) => {
    useEffect(NavBar.setup(props), []);
    useEffect(function () {
      Navigation.setButtons(
        {
          leftButtons: [NavBar.buttons.done],
        },
        props.componentId
      );
    }, []);

    const [addToExisting, setAddToExisting] = useState(false);
    const [selected, setSelected] = useState({});

    const handleCancel = useCallback(() => Navigation.close(props), []);
    const handleSave = useCallback(() => {
      let members = Object.keys(selected).reduce((result, k) => {
        if (selected[k]) result.push({ userId: parseInt(k) });
        return result;
      }, []);
      if (!addToExisting) {
        members = members.concat({
          userId: props.user.userId,
        });
        props.actions.createTopic({
          name: '_',
          description: '',
          members,
        });
      } else {
        members = members.filter(
          (m) => !props.currentTopic.members.find((m2) => m.userId === (m2.profile || m2).userId)
        );
        if (members.length) {
          props.actions.updateTopic({
            name: props.currentTopic.name,
            description: props.currentTopic.description,
            members,
          });
        }
      }
      Navigation.close(props);
    }, [selected, addToExisting]);

    function renderItem({ item, index }) {
      const bgStyle = index % 2 !== 0 ? styles.altRow : null;
      function handleSelectedCheck() {
        setSelected({
          ...selected,
          [item.userId]: !selected[item.userId],
        });
      }

      const subLabel = item.medicalService
        ? `${item.medicalService}  |  ${item.clinicalLocation}`
        : item.roleTitle || '';
      return (
        <Pressable style={[styles.rowItem, bgStyle]} onPress={handleSelectedCheck}>
          <CheckBox checked={selected[item.userId]} onCheck={handleSelectedCheck} />
          <View style={{ flex: 1, paddingLeft: __WEB__ ? 10 : 0 }}>
            <Text style={[styles.rowItemLabel]}>
              {item.rank ? `${item.rank} ` : ''}
              {item.fullName}
            </Text>
            {!!subLabel && <Text style={[styles.rowItemSubLabel]}>{subLabel}</Text>}
          </View>
        </Pressable>
      );
    }

    function handleAddToExistingCheck(checked) {
      setAddToExisting(checked);
    }

    const createButtonLabel = addToExisting ? 'Add to Group Message' : 'Create New Group Message';
    const selectedCount = Object.keys(selected).reduce((result, k) => {
      if (selected[k]) result++;
      return result;
    }, 0);

    const footer = (
      <FormFooter
        onCancel={handleCancel}
        onSave={handleSave}
        saveLabel={createButtonLabel}
        saveDisabled={!selectedCount}
      >
        {!!props.currentTopic?.closed && (
          <View style={styles.addToExisting}>
            <CheckBox checked={addToExisting} onCheck={handleAddToExistingCheck} />
            <Text style={styles.addToExistingLabel}>Add user to existing message thread</Text>
          </View>
        )}
      </FormFooter>
    );

    return (
      <Container style={styles.container}>
        <View style={{ flex: 1 }}>
          <FlatList
            data={props.followers}
            renderItem={renderItem}
            keyExtractor={function (item) {
              return `${item.userId}`;
            }}
          />
        </View>
        {footer}
      </Container>
    );
  })
);

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
  },
  rowItem: {
    ...THEME.basicRow,
    paddingLeft: __WEB__ ? 30 : 20,
    paddingVertical: 10,
  },
  altRow: {
    backgroundColor: COLOR.altContrast,
  },
  rowItemLabel: {
    ...FONT.medium,
    paddingHorizontal: 20,
    color: COLOR.text,
    fontSize: 14,
  },
  rowItemSubLabel: {
    ...FONT.medium,
    paddingHorizontal: 20,
    color: COLOR.textLight,
    fontSize: 14,
    marginTop: 5,
  },
  addToExisting: {
    ...THEME.basicRow,
    flex: 1,
    justifyContent: 'flex-end',
    paddingRight: 20,
  },
  addToExistingLabel: {
    ...FONT.regular,
    color: COLOR.text,
    marginLeft: 10,
  },
});
